import { format, formatDistanceToNow } from 'date-fns';
import { fr } from 'date-fns/locale';
import { useGetInboxSyncStatus } from '../../api/useGetInboxSyncStatus';

type Props = {
  spaceId?: string;
};

export function useSyncStatusBadge(props: Props) {
  const { data: lastSyncAt, isLoading } = useGetInboxSyncStatus({
    spaceId: props.spaceId,
  });

  if (isLoading || !lastSyncAt) {
    return {
      status: 'never' as const,
      label: 'Non synchronisé',
      tooltip: 'Aucune synchronisation Gmail détectée. Utilisez « Configurer Gmail » pour commencer.',
    };
  }

  const syncDate = new Date(lastSyncAt);
  const diffMinutes = (Date.now() - syncDate.getTime()) / (1000 * 60);

  const formattedExact = format(syncDate, "d MMMM yyyy 'à' HH'h'mm", { locale: fr });
  const timeAgo = formatDistanceToNow(syncDate, { addSuffix: true, locale: fr });

  if (diffMinutes < 15) {
    return {
      status: 'fresh' as const,
      label: `Synchronisé ${timeAgo}`,
      tooltip: `Dernière vérification Gmail : ${formattedExact}`,
    };
  }

  if (diffMinutes < 120) {
    return {
      status: 'delayed' as const,
      label: `Dernière synchro ${timeAgo}`,
      tooltip: `Dernière vérification Gmail : ${formattedExact}`,
    };
  }

  return {
    status: 'stale' as const,
    label: `Dernière synchro ${timeAgo}`,
    tooltip: `Dernière vérification Gmail : ${formattedExact}. Vérifiez que le déclencheur Google Apps Script est actif.`,
  };
}
